<div class="py-7 bg-radiant">
  <router-outlet></router-outlet>
</div>
